module.exports = __webpack_public_path__ + "img/1479225071.48506845.jpg";